module.exports = __webpack_public_path__ + "static/hand_sewn_mask-f3302da2ffd2b2157b76e0edbb53b11c.png";